/**
 * API Headers Utility
 *
 * Functions to generate consistent request headers for API calls.
 * These headers include authentication tokens and client identifiers.
 */

/**
 * Content format options for API requests
 */
export type ContentFormat = "json" | "file";

/**
 * Builds request headers for client-specific API endpoints
 *
 * @param format - The content format ('json' or 'file')
 * @returns Object containing properly formatted headers
 */
export const buildClientHeader = (format: ContentFormat = "json") => {
  const token = localStorage.getItem("token") || "";
  const client = localStorage.getItem("clientKey") || "";

  return {
    headers: {
      accept: "text/plain",
      "Content-Type":
        format === "file" ? "multipart/form-data" : "application/json",
      Authorization: token,
      Client: client,
    },
  };
};

/**
 * Builds request headers for fund-specific API endpoints
 *
 * @param fundId - The ID of the fund being accessed
 * @param format - The content format ('json' or 'file')
 * @returns Object containing properly formatted headers
 */
export const buildClientAndFundHeader = (
  fundId: number,
  format: ContentFormat = "json"
) => {
  const token = localStorage.getItem("token") || "";
  const client = localStorage.getItem("clientKey") || "";

  return {
    headers: {
      accept: "text/plain",
      "Content-Type":
        format === "file" ? "multipart/form-data" : "application/json",
      Authorization: token,
      Client: client,
      fundId: fundId.toString(),
    },
  };
};
